import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createBlock as _createBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-7be17cba"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "usuarios-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "usuarios-content" };
const _hoisted_4 = { class: "content-header" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Gestión de Usuarios", -1 /* HOISTED */));
const _hoisted_6 = { class: "header-top-controls" };
const _hoisted_7 = { class: "search-container" };
const _hoisted_8 = { class: "search-wrapper" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Nuevo Usuario", -1 /* HOISTED */));
const _hoisted_10 = { class: "table-container" };
const _hoisted_11 = { class: "marcas-table" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Usuario"),
        /*#__PURE__*/ _createElementVNode("th", null, "Clasificación"),
        /*#__PURE__*/ _createElementVNode("th", null, "Rol de Sistema"),
        /*#__PURE__*/ _createElementVNode("th", null, "Registro"),
        /*#__PURE__*/ _createElementVNode("th", null, "Última Actividad"),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "Estado"),
        /*#__PURE__*/ _createElementVNode("th", { class: "actions-column" }, "Acciones")
    ])
], -1 /* HOISTED */));
const _hoisted_13 = { key: 0 };
const _hoisted_14 = {
    colspan: "6",
    class: "text-center py-8"
};
const _hoisted_15 = { class: "loading-state" };
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", { class: "mt-2" }, "Cargando usuarios...", -1 /* HOISTED */));
const _hoisted_17 = { key: 1 };
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("td", {
    colspan: "6",
    class: "text-center py-4"
}, "No se encontraron resultados.", -1 /* HOISTED */));
const _hoisted_19 = [
    _hoisted_18
];
const _hoisted_20 = { class: "user-cell" };
const _hoisted_21 = { class: "avatar-sm" };
const _hoisted_22 = { class: "user-details" };
const _hoisted_23 = { class: "user-name" };
const _hoisted_24 = { class: "user-email" };
const _hoisted_25 = { class: "type-badge" };
const _hoisted_26 = { class: "text-center" };
const _hoisted_27 = { class: "actions-column actions-cell" };
const _hoisted_28 = ["onClick", "title"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
    key: 0,
    class: "pagination-controls"
};
const _hoisted_32 = ["disabled"];
const _hoisted_33 = { class: "pagination-info" };
const _hoisted_34 = ["disabled"];
const _hoisted_35 = { class: "modal-box" };
const _hoisted_36 = { class: "modal-header" };
const _hoisted_37 = { class: "modal-header-info" };
const _hoisted_38 = { class: "form-section" };
const _hoisted_39 = { class: "form-section-title" };
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Datos Básicos", -1 /* HOISTED */));
const _hoisted_41 = { class: "form-grid-2" };
const _hoisted_42 = { class: "form-group" };
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Nombre o Razón Social "),
    /*#__PURE__*/ _createElementVNode("span", { class: "req" }, "*")
], -1 /* HOISTED */));
const _hoisted_44 = { class: "input-with-action" };
const _hoisted_45 = ["disabled"];
const _hoisted_46 = ["title"];
const _hoisted_47 = { class: "form-group" };
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Cédula o RIF "),
    /*#__PURE__*/ _createElementVNode("span", { class: "req" }, "*")
], -1 /* HOISTED */));
const _hoisted_49 = { class: "input-with-action" };
const _hoisted_50 = ["disabled"];
const _hoisted_51 = ["title"];
const _hoisted_52 = { class: "form-group" };
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Correo Electrónico "),
    /*#__PURE__*/ _createElementVNode("span", { class: "req" }, "*")
], -1 /* HOISTED */));
const _hoisted_54 = { class: "input-with-action" };
const _hoisted_55 = ["disabled"];
const _hoisted_56 = ["title"];
const _hoisted_57 = { class: "form-group" };
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Tipo de Cliente "),
    /*#__PURE__*/ _createElementVNode("span", { class: "req" }, "*")
], -1 /* HOISTED */));
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccione un tipo...", -1 /* HOISTED */));
const _hoisted_60 = ["value"];
const _hoisted_61 = { class: "form-group" };
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, [
    /*#__PURE__*/ _createTextVNode("Rol de Sistema "),
    /*#__PURE__*/ _createElementVNode("span", { class: "req" }, "*")
], -1 /* HOISTED */));
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccione un rol...", -1 /* HOISTED */));
const _hoisted_64 = ["value"];
const _hoisted_65 = { class: "form-group" };
const _hoisted_66 = {
    key: 0,
    class: "req"
};
const _hoisted_67 = { class: "input-with-action" };
const _hoisted_68 = ["placeholder", "required", "disabled"];
const _hoisted_69 = ["title"];
const _hoisted_70 = { class: "form-group" };
const _hoisted_71 = {
    key: 0,
    class: "req"
};
const _hoisted_72 = { class: "input-with-action" };
const _hoisted_73 = ["placeholder", "required", "disabled"];
const _hoisted_74 = {
    key: 0,
    class: "field-error"
};
const _hoisted_75 = { class: "form-section" };
const _hoisted_76 = { class: "form-section-title" };
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Dirección y Contacto", -1 /* HOISTED */));
const _hoisted_78 = { class: "form-grid-2" };
const _hoisted_79 = { class: "form-group" };
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Dirección", -1 /* HOISTED */));
const _hoisted_81 = { class: "form-group" };
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Ciudad", -1 /* HOISTED */));
const _hoisted_83 = { class: "form-group" };
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Estado", -1 /* HOISTED */));
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccione un estado...", -1 /* HOISTED */));
const _hoisted_86 = ["value"];
const _hoisted_87 = { class: "form-group" };
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Número Celular", -1 /* HOISTED */));
const _hoisted_89 = { class: "input-prefix" };
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "🇻🇪 +58", -1 /* HOISTED */));
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "🇺🇸 +1", -1 /* HOISTED */));
const _hoisted_92 = [
    _hoisted_90,
    _hoisted_91
];
const _hoisted_93 = { class: "form-group" };
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Número WhatsApp", -1 /* HOISTED */));
const _hoisted_95 = { class: "input-prefix" };
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+58" }, "🇻🇪 +58", -1 /* HOISTED */));
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", { value: "+1" }, "🇺🇸 +1", -1 /* HOISTED */));
const _hoisted_98 = [
    _hoisted_96,
    _hoisted_97
];
const _hoisted_99 = { class: "form-group" };
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Número Fijo", -1 /* HOISTED */));
const _hoisted_101 = { class: "form-section" };
const _hoisted_102 = { class: "form-section-title" };
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Información Comercial", -1 /* HOISTED */));
const _hoisted_104 = { class: "form-grid-2" };
const _hoisted_105 = { class: "form-group" };
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Tipo de Comercio", -1 /* HOISTED */));
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("option", {
    value: "",
    disabled: ""
}, "Seleccione tipo...", -1 /* HOISTED */));
const _hoisted_108 = ["value"];
const _hoisted_109 = { class: "form-group" };
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Página Web", -1 /* HOISTED */));
const _hoisted_111 = { class: "form-group" };
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "ID Instagram", -1 /* HOISTED */));
const _hoisted_113 = { class: "form-group" };
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "ID TikTok", -1 /* HOISTED */));
const _hoisted_115 = { class: "form-group" };
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre en Facebook", -1 /* HOISTED */));
const _hoisted_117 = { class: "form-section" };
const _hoisted_118 = { class: "form-section-title" };
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Representante", -1 /* HOISTED */));
const _hoisted_120 = { class: "form-grid-2" };
const _hoisted_121 = { class: "form-group" };
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Nombre del Representante", -1 /* HOISTED */));
const _hoisted_123 = { class: "form-group" };
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Cédula del Representante", -1 /* HOISTED */));
const _hoisted_125 = { class: "form-group" };
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Teléfono del Representante", -1 /* HOISTED */));
const _hoisted_127 = { class: "form-group" };
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", null, "Cargo del Representante", -1 /* HOISTED */));
const _hoisted_129 = { class: "modal-footer" };
const _hoisted_130 = ["disabled"];
import { ref, onMounted, watch } from 'vue';
import Header from '@/components/HeaderDashboard.vue';
import Sidebar from '@/components/Sidebar.vue';
import { SearchIcon, PlusIcon, Loader2Icon, PowerIcon, TrashIcon, XIcon, EditIcon, ChevronLeftIcon, ChevronRightIcon, UserIcon, MapPinIcon, BriefcaseIcon, UsersIcon, LockIcon, UnlockIcon } from 'lucide-vue-next';
import { UserService } from '@/services/UserService';
import { EstadoService } from '@/services/EstadoService';
import { TipoComercioService } from '@/services/TipoComercioService';
import Swal from 'sweetalert2';
import { hasPermission } from '@/store/userStore';
import { PERMISSIONS } from '@/constants/permissions';
const pageSize = 10;
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            }
        });
        const usuarios = ref([]);
        const roles = ref([]);
        const tiposUsuario = ref([]);
        const estados = ref([]);
        const tiposComercios = ref([]);
        const isLoading = ref(true);
        const isModalOpen = ref(false);
        const isSaving = ref(false);
        const isEditMode = ref(false);
        const editingUserId = ref(null);
        const searchQuery = ref('');
        const currentPage = ref(1);
        const totalPages = ref(1);
        const unlockedFields = ref({
            nombre: false,
            cedulaORif: false,
            email: false,
            password: false
        });
        const confirmUnlock = async (field) => {
            if (unlockedFields.value[field])
                return; // Already unlocked
            const fieldNames = {
                nombre: 'Nombre o Razón Social',
                cedulaORif: 'Cédula o RIF',
                email: 'Correo Electrónico',
                password: 'Contraseña'
            };
            const result = await Swal.fire({
                title: '¿Deseas editar este campo?',
                text: `El campo "${fieldNames[field]}" es un dato sensible. ¿Estás seguro de que deseas modificarlo?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, permitir edición',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#3b82f6',
                cancelButtonColor: '#94a3b8',
            });
            if (result.isConfirmed) {
                unlockedFields.value[field] = true;
            }
        };
        const emptyForm = () => ({
            // Básicos
            nombre: '',
            nombreORazonSocial: '',
            cedulaORif: '',
            email: '',
            password: '',
            confirmPassword: '',
            tipoUsuarioId: '',
            rolId: '',
            // Contacto
            prefixCelular: '+58',
            numeroCelular: '',
            prefixWhatsapp: '+58',
            numeroWhatsapp: '',
            numeroFijo: '',
            direccion: '',
            ciudad: '',
            estadoId: '',
            // Comercial
            tipoComercioId: '',
            paginaWeb: '',
            idInstagram: '',
            idTikTok: '',
            nombreFacebook: '',
            // Representante
            nombreRepresentante: '',
            cedula: '',
            numeroTelefono: '',
            cargo: '',
        });
        const P = PERMISSIONS;
        const can = hasPermission;
        const form = ref(emptyForm());
        const loadData = async () => {
            isLoading.value = true;
            try {
                const res = await UserService.getUsuarios(searchQuery.value, currentPage.value, pageSize);
                if (res?.exito) {
                    const datos = res.datos;
                    usuarios.value = datos.items || datos.Items || [];
                    const totalCount = datos.totalCount || datos.TotalCount || 0;
                    totalPages.value = Math.ceil(totalCount / pageSize) || 1;
                }
            }
            catch (error) {
                console.error('Error al cargar usuarios:', error);
            }
            finally {
                isLoading.value = false;
            }
        };
        const loadSelectData = async () => {
            try {
                const [rolesRes, typesRes, estadosRes, comerciosRes] = await Promise.all([
                    UserService.getRoles(),
                    UserService.getTiposUsuario(),
                    EstadoService.getAllCiudades(),
                    TipoComercioService.getAllTipoComercios(),
                ]);
                if (rolesRes?.exito)
                    roles.value = rolesRes.datos || rolesRes.Datos || [];
                if (typesRes?.exito)
                    tiposUsuario.value = typesRes.data || typesRes.datos || [];
                if (Array.isArray(estadosRes))
                    estados.value = estadosRes;
                if (Array.isArray(comerciosRes))
                    tiposComercios.value = comerciosRes;
            }
            catch (error) {
                console.error('Error cargando selects:', error);
            }
        };
        const openModal = () => {
            form.value = emptyForm();
            isEditMode.value = false;
            editingUserId.value = null;
            unlockedFields.value = { nombre: false, cedulaORif: false, email: false, password: false };
            isModalOpen.value = true;
        };
        const editUser = (user) => {
            isEditMode.value = true;
            editingUserId.value = user.usuarioId;
            unlockedFields.value = { nombre: false, cedulaORif: false, email: false, password: false };
            // Extract phone numbers and prefixes
            let prefixCelular = '+58';
            let numeroCelular = user.numeroCelular || '';
            if (numeroCelular && numeroCelular.startsWith('+58')) {
                prefixCelular = '+58';
                numeroCelular = numeroCelular.replace('+58', '');
            }
            else if (numeroCelular && numeroCelular.startsWith('+1')) {
                prefixCelular = '+1';
                numeroCelular = numeroCelular.replace('+1', '');
            }
            let prefixWhatsapp = '+58';
            let numeroWhatsapp = user.numeroWhatsapp || '';
            if (numeroWhatsapp && numeroWhatsapp.startsWith('+58')) {
                prefixWhatsapp = '+58';
                numeroWhatsapp = numeroWhatsapp.replace('+58', '');
            }
            else if (numeroWhatsapp && numeroWhatsapp.startsWith('+1')) {
                prefixWhatsapp = '+1';
                numeroWhatsapp = numeroWhatsapp.replace('+1', '');
            }
            form.value = {
                nombre: (user.nombreORazonSocial || user.nombre) || '',
                nombreORazonSocial: user.nombreORazonSocial || '',
                cedulaORif: user.cedulaORif || '',
                email: user.email || '',
                password: '',
                confirmPassword: '',
                tipoUsuarioId: user.tipoUsuarioId || '',
                rolId: user.rolId || '',
                prefixCelular,
                numeroCelular,
                prefixWhatsapp,
                numeroWhatsapp,
                numeroFijo: user.numeroFijo || '',
                direccion: user.direccion || '',
                ciudad: user.ciudad || '',
                estadoId: user.estadoId || '',
                tipoComercioId: user.tipoComercioId || '',
                paginaWeb: user.paginaWeb || '',
                idInstagram: user.idInstagram || '',
                idTikTok: user.idTikTok || '',
                nombreFacebook: user.nombreFacebook || '',
                nombreRepresentante: user.nombreRepresentante || '',
                cedula: user.cedula || '',
                numeroTelefono: user.numeroTelefono || '',
                cargo: user.cargo || '',
            };
            isModalOpen.value = true;
        };
        const saveUser = async () => {
            if (form.value.password && form.value.password !== form.value.confirmPassword) {
                Swal.fire('Error', 'Las contraseñas no coinciden', 'error');
                return;
            }
            isSaving.value = true;
            try {
                const payload = {
                    nombre: form.value.nombre,
                    nombreORazonSocial: form.value.nombre,
                    cedulaORif: form.value.cedulaORif,
                    email: form.value.email,
                    password: form.value.password || undefined,
                    tipoUsuarioId: form.value.tipoUsuarioId,
                    rolId: form.value.rolId,
                    direccion: form.value.direccion,
                    ciudad: form.value.ciudad,
                    estadoId: form.value.estadoId || null,
                    numeroCelular: form.value.numeroCelular ? `${form.value.prefixCelular}${form.value.numeroCelular}` : '',
                    numeroWhatsapp: form.value.numeroWhatsapp ? `${form.value.prefixWhatsapp}${form.value.numeroWhatsapp}` : '',
                    numeroFijo: form.value.numeroFijo,
                    tipoComercioId: form.value.tipoComercioId || null,
                    paginaWeb: form.value.paginaWeb,
                    idInstagram: form.value.idInstagram,
                    idTikTok: form.value.idTikTok,
                    nombreFacebook: form.value.nombreFacebook,
                    nombreRepresentante: form.value.nombreRepresentante,
                    cedula: form.value.cedula,
                    numeroTelefono: form.value.numeroTelefono,
                    cargo: form.value.cargo,
                    isAdmin: false
                };
                if (isEditMode.value && editingUserId.value) {
                    const res = await UserService.updateUsuario(editingUserId.value, payload);
                    if (res.exito) {
                        Toast.fire({ icon: 'success', title: 'Usuario actualizado correctamente' });
                        isModalOpen.value = false;
                        loadData();
                    }
                }
                else {
                    const res = await UserService.createUsuario(payload);
                    if (res.exito) {
                        Toast.fire({ icon: 'success', title: 'Usuario creado correctamente' });
                        isModalOpen.value = false;
                        loadData();
                    }
                }
            }
            catch (error) {
                Swal.fire('Error', error.message || 'Error al guardar usuario', 'error');
            }
            finally {
                isSaving.value = false;
            }
        };
        const toggleStatus = async (user) => {
            const result = await Swal.fire({
                title: '¿Cambiar estado?',
                text: `¿Estás seguro de que deseas ${user.isActive ? 'desactivar' : 'activar'} a este usuario?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, cambiar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#3b82f6',
                cancelButtonColor: '#94a3b8',
            });
            if (!result.isConfirmed)
                return;
            try {
                const res = await UserService.toggleStatus(user.usuarioId);
                if (res.exito) {
                    user.isActive = !user.isActive;
                    Swal.fire({ title: user.isActive ? 'Activado' : 'Desactivado', icon: 'success', timer: 1500, showConfirmButton: false, toast: true, position: 'top-end' });
                }
            }
            catch {
                Swal.fire('Error', 'No se pudo cambiar el estado', 'error');
            }
        };
        const confirmDelete = async (id) => {
            const result = await Swal.fire({
                title: '¿Estás seguro?', text: 'Esta acción eliminará al usuario permanentemente',
                icon: 'warning', showCancelButton: true, confirmButtonText: 'Sí, eliminar', cancelButtonText: 'Cancelar'
            });
            if (result.isConfirmed) {
                try {
                    const res = await UserService.deleteUsuario(id);
                    if (res.exito) {
                        Toast.fire({ icon: 'success', title: 'Usuario eliminado correctamente' });
                        loadData();
                    }
                }
                catch {
                    Swal.fire('Error', 'No se pudo eliminar al usuario', 'error');
                }
            }
        };
        const formatDate = (date) => {
            if (!date)
                return '-';
            return new Date(date).toLocaleDateString('es-ES', { year: 'numeric', month: 'short', day: 'numeric' });
        };
        const getRoleClass = (id) => {
            switch (id) {
                case 1: return 'role-admin';
                case 2: return 'role-staff';
                default: return 'role-user';
            }
        };
        const prevPage = () => { if (currentPage.value > 1) {
            currentPage.value--;
            loadData();
        } };
        const nextPage = () => { if (currentPage.value < totalPages.value) {
            currentPage.value++;
            loadData();
        } };
        let searchTimeout;
        watch(searchQuery, () => {
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => { currentPage.value = 1; loadData(); }, 500);
        });
        onMounted(() => { loadData(); loadSelectData(); });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Header),
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(Sidebar),
                    _createElementVNode("div", _hoisted_3, [
                        _createCommentVNode(" Cabecera "),
                        _createElementVNode("div", _hoisted_4, [
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_unref(SearchIcon), {
                                            size: 18,
                                            class: "search-icon"
                                        }),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event)),
                                            placeholder: "Buscar por nombre o email...",
                                            class: "search-input"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [_vModelText, searchQuery.value]
                                        ])
                                    ])
                                ]),
                                (_unref(can)(_unref(P).USUARIOS.CREATE))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        onClick: _cache[1] || (_cache[1] = ($event) => (openModal())),
                                        class: "btn btn-add"
                                    }, [
                                        _createVNode(_unref(PlusIcon), { size: 18 }),
                                        _hoisted_9
                                    ]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ]),
                        _createCommentVNode(" Tabla "),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("table", _hoisted_11, [
                                _hoisted_12,
                                _createElementVNode("tbody", null, [
                                    (isLoading.value)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                                            _createElementVNode("td", _hoisted_14, [
                                                _createElementVNode("div", _hoisted_15, [
                                                    _createVNode(_unref(Loader2Icon), {
                                                        class: "spinner-icon",
                                                        size: 32
                                                    }),
                                                    _hoisted_16
                                                ])
                                            ])
                                        ]))
                                        : (usuarios.value.length === 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_19))
                                            : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usuarios.value, (user) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: user.usuarioId
                                        }, [
                                            _createElementVNode("td", null, [
                                                _createElementVNode("div", _hoisted_20, [
                                                    _createElementVNode("div", _hoisted_21, _toDisplayString(user.nombre?.charAt(0).toUpperCase() || 'U'), 1 /* TEXT */),
                                                    _createElementVNode("div", _hoisted_22, [
                                                        _createElementVNode("span", _hoisted_23, _toDisplayString(user.nombre), 1 /* TEXT */),
                                                        _createElementVNode("span", _hoisted_24, _toDisplayString(user.email), 1 /* TEXT */)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", _hoisted_25, _toDisplayString(user.tipoUsuarioNombre), 1 /* TEXT */)
                                            ]),
                                            _createElementVNode("td", null, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["role-badge", getRoleClass(user.rolId)])
                                                }, _toDisplayString(user.rolNombre), 3 /* TEXT, CLASS */)
                                            ]),
                                            _createElementVNode("td", null, _toDisplayString(formatDate(user.fechaRegistro)), 1 /* TEXT */),
                                            _createElementVNode("td", null, _toDisplayString(user.ultimaActividad ? formatDate(user.ultimaActividad) : 'Nunca'), 1 /* TEXT */),
                                            _createElementVNode("td", _hoisted_26, [
                                                _createElementVNode("span", {
                                                    class: _normalizeClass(["status-badge", user.isActive ? 'active' : 'inactive'])
                                                }, _toDisplayString(user.isActive ? 'Activo' : 'Inactivo'), 3 /* TEXT, CLASS */)
                                            ]),
                                            _createElementVNode("td", _hoisted_27, [
                                                (_unref(can)(_unref(P).USUARIOS.EDIT))
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        onClick: ($event) => (toggleStatus(user)),
                                                        class: "btn-icon btn-toggle",
                                                        title: user.isActive ? 'Desactivar' : 'Activar'
                                                    }, [
                                                        _createVNode(_unref(PowerIcon), {
                                                            size: 18,
                                                            class: _normalizeClass(user.isActive ? 'text-success' : 'text-danger')
                                                        }, null, 8 /* PROPS */, ["class"])
                                                    ], 8 /* PROPS */, _hoisted_28))
                                                    : _createCommentVNode("v-if", true),
                                                (_unref(can)(_unref(P).USUARIOS.EDIT))
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        onClick: ($event) => (editUser(user)),
                                                        class: "btn-icon btn-toggle",
                                                        title: "Editar"
                                                    }, [
                                                        _createVNode(_unref(EditIcon), {
                                                            size: 18,
                                                            class: "text-primary"
                                                        })
                                                    ], 8 /* PROPS */, _hoisted_29))
                                                    : _createCommentVNode("v-if", true),
                                                (_unref(can)(_unref(P).USUARIOS.DELETE))
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 2,
                                                        onClick: ($event) => (confirmDelete(user.usuarioId)),
                                                        class: "btn-icon btn-delete",
                                                        title: "Eliminar"
                                                    }, [
                                                        _createVNode(_unref(TrashIcon), { size: 18 })
                                                    ], 8 /* PROPS */, _hoisted_30))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ])
                        ]),
                        _createCommentVNode(" Paginación "),
                        (totalPages.value > 1)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createElementVNode("button", {
                                    onClick: prevPage,
                                    disabled: currentPage.value === 1,
                                    class: "btn-pagination"
                                }, [
                                    _createVNode(_unref(ChevronLeftIcon), { size: 18 })
                                ], 8 /* PROPS */, _hoisted_32),
                                _createElementVNode("span", _hoisted_33, "Página " + _toDisplayString(currentPage.value) + " de " + _toDisplayString(totalPages.value), 1 /* TEXT */),
                                _createElementVNode("button", {
                                    onClick: nextPage,
                                    disabled: currentPage.value === totalPages.value,
                                    class: "btn-pagination"
                                }, [
                                    _createVNode(_unref(ChevronRightIcon), { size: 18 })
                                ], 8 /* PROPS */, _hoisted_34)
                            ]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createCommentVNode(" ========== MODAL CON FORMULARIO COMPLETO ========== "),
                (isModalOpen.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-overlay",
                        onClick: _cache[32] || (_cache[32] = _withModifiers(($event) => (isModalOpen.value = false), ["self"]))
                    }, [
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("h2", null, _toDisplayString(isEditMode.value ? 'Editar Usuario' : 'Registrar Nuevo Usuario'), 1 /* TEXT */),
                                    _createElementVNode("p", null, _toDisplayString(isEditMode.value ? 'Actualiza la información del usuario' : 'Completa toda la información del usuario'), 1 /* TEXT */)
                                ]),
                                _createElementVNode("button", {
                                    onClick: _cache[2] || (_cache[2] = ($event) => (isModalOpen.value = false)),
                                    class: "btn-close"
                                }, [
                                    _createVNode(_unref(XIcon), {
                                        color: "white",
                                        size: 22
                                    })
                                ])
                            ]),
                            _createElementVNode("form", {
                                onSubmit: _withModifiers(saveUser, ["prevent"]),
                                class: "modal-form"
                            }, [
                                _createCommentVNode(" ====== SECCIÓN 1: DATOS BÁSICOS ====== "),
                                _createElementVNode("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                        _createVNode(_unref(UserIcon), { size: 16 }),
                                        _hoisted_40
                                    ]),
                                    _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("div", _hoisted_42, [
                                            _hoisted_43,
                                            _createElementVNode("div", _hoisted_44, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((form.value.nombre) = $event)),
                                                    type: "text",
                                                    placeholder: "Juan Pérez / Empresa S.A.",
                                                    required: "",
                                                    disabled: isEditMode.value && !unlockedFields.value.nombre
                                                }, null, 8 /* PROPS */, _hoisted_45), [
                                                    [_vModelText, form.value.nombre]
                                                ]),
                                                (isEditMode.value)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        type: "button",
                                                        class: "btn-unlock",
                                                        onClick: _cache[4] || (_cache[4] = ($event) => (confirmUnlock('nombre'))),
                                                        title: unlockedFields.value.nombre ? 'Campo desbloqueado' : 'Haga clic para editar este campo'
                                                    }, [
                                                        (unlockedFields.value.nombre)
                                                            ? (_openBlock(), _createBlock(_unref(UnlockIcon), {
                                                                key: 0,
                                                                size: 16
                                                            }))
                                                            : (_openBlock(), _createBlock(_unref(LockIcon), {
                                                                key: 1,
                                                                size: 16
                                                            }))
                                                    ], 8 /* PROPS */, _hoisted_46))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_47, [
                                            _hoisted_48,
                                            _createElementVNode("div", _hoisted_49, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.value.cedulaORif) = $event)),
                                                    type: "text",
                                                    placeholder: "V-12345678 / J-12345678",
                                                    required: "",
                                                    disabled: isEditMode.value && !unlockedFields.value.cedulaORif
                                                }, null, 8 /* PROPS */, _hoisted_50), [
                                                    [_vModelText, form.value.cedulaORif]
                                                ]),
                                                (isEditMode.value)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        type: "button",
                                                        class: "btn-unlock",
                                                        onClick: _cache[6] || (_cache[6] = ($event) => (confirmUnlock('cedulaORif'))),
                                                        title: unlockedFields.value.cedulaORif ? 'Campo desbloqueado' : 'Haga clic para editar este campo'
                                                    }, [
                                                        (unlockedFields.value.cedulaORif)
                                                            ? (_openBlock(), _createBlock(_unref(UnlockIcon), {
                                                                key: 0,
                                                                size: 16
                                                            }))
                                                            : (_openBlock(), _createBlock(_unref(LockIcon), {
                                                                key: 1,
                                                                size: 16
                                                            }))
                                                    ], 8 /* PROPS */, _hoisted_51))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_52, [
                                            _hoisted_53,
                                            _createElementVNode("div", _hoisted_54, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.value.email) = $event)),
                                                    type: "email",
                                                    placeholder: "usuario@correo.com",
                                                    required: "",
                                                    disabled: isEditMode.value && !unlockedFields.value.email
                                                }, null, 8 /* PROPS */, _hoisted_55), [
                                                    [_vModelText, form.value.email]
                                                ]),
                                                (isEditMode.value)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        type: "button",
                                                        class: "btn-unlock",
                                                        onClick: _cache[8] || (_cache[8] = ($event) => (confirmUnlock('email'))),
                                                        title: unlockedFields.value.email ? 'Campo desbloqueado' : 'Haga clic para editar este campo'
                                                    }, [
                                                        (unlockedFields.value.email)
                                                            ? (_openBlock(), _createBlock(_unref(UnlockIcon), {
                                                                key: 0,
                                                                size: 16
                                                            }))
                                                            : (_openBlock(), _createBlock(_unref(LockIcon), {
                                                                key: 1,
                                                                size: 16
                                                            }))
                                                    ], 8 /* PROPS */, _hoisted_56))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_57, [
                                            _hoisted_58,
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((form.value.tipoUsuarioId) = $event)),
                                                required: ""
                                            }, [
                                                _hoisted_59,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposUsuario.value, (tipo) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: tipo.tipoUsuarioId,
                                                        value: tipo.tipoUsuarioId
                                                    }, _toDisplayString(tipo.nombre), 9 /* TEXT, PROPS */, _hoisted_60));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ], 512 /* NEED_PATCH */), [
                                                [_vModelSelect, form.value.tipoUsuarioId]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_61, [
                                            _hoisted_62,
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((form.value.rolId) = $event)),
                                                required: ""
                                            }, [
                                                _hoisted_63,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roles.value, (rol) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: rol.rolId,
                                                        value: rol.rolId
                                                    }, _toDisplayString(rol.nombre), 9 /* TEXT, PROPS */, _hoisted_64));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ], 512 /* NEED_PATCH */), [
                                                [_vModelSelect, form.value.rolId]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_65, [
                                            _createElementVNode("label", null, [
                                                _createTextVNode("Contraseña "),
                                                (!isEditMode.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_66, "*"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_67, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((form.value.password) = $event)),
                                                    type: "password",
                                                    placeholder: isEditMode.value ? 'Dejar en blanco para mantener actual' : 'Mínimo 8 caracteres',
                                                    required: !isEditMode.value,
                                                    disabled: isEditMode.value && !unlockedFields.value.password
                                                }, null, 8 /* PROPS */, _hoisted_68), [
                                                    [_vModelText, form.value.password]
                                                ]),
                                                (isEditMode.value)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        type: "button",
                                                        class: "btn-unlock",
                                                        onClick: _cache[12] || (_cache[12] = ($event) => (confirmUnlock('password'))),
                                                        title: unlockedFields.value.password ? 'Campo desbloqueado' : 'Haga clic para editar este campo'
                                                    }, [
                                                        (unlockedFields.value.password)
                                                            ? (_openBlock(), _createBlock(_unref(UnlockIcon), {
                                                                key: 0,
                                                                size: 16
                                                            }))
                                                            : (_openBlock(), _createBlock(_unref(LockIcon), {
                                                                key: 1,
                                                                size: 16
                                                            }))
                                                    ], 8 /* PROPS */, _hoisted_69))
                                                    : _createCommentVNode("v-if", true)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_70, [
                                            _createElementVNode("label", null, [
                                                _createTextVNode("Confirmar Contraseña "),
                                                (!isEditMode.value)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_71, "*"))
                                                    : _createCommentVNode("v-if", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_72, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((form.value.confirmPassword) = $event)),
                                                    type: "password",
                                                    placeholder: isEditMode.value ? 'Repetir nueva contraseña' : 'Repetir contraseña',
                                                    required: !isEditMode.value && !!form.value.password,
                                                    disabled: isEditMode.value && !unlockedFields.value.password
                                                }, null, 8 /* PROPS */, _hoisted_73), [
                                                    [_vModelText, form.value.confirmPassword]
                                                ])
                                            ]),
                                            (form.value.confirmPassword && form.value.password !== form.value.confirmPassword)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_74, " Las contraseñas no coinciden "))
                                                : _createCommentVNode("v-if", true)
                                        ])
                                    ])
                                ]),
                                _createCommentVNode(" ====== SECCIÓN 2: DIRECCIÓN Y CONTACTO ====== "),
                                _createElementVNode("div", _hoisted_75, [
                                    _createElementVNode("div", _hoisted_76, [
                                        _createVNode(_unref(MapPinIcon), { size: 16 }),
                                        _hoisted_77
                                    ]),
                                    _createElementVNode("div", _hoisted_78, [
                                        _createElementVNode("div", _hoisted_79, [
                                            _hoisted_80,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((form.value.direccion) = $event)),
                                                type: "text",
                                                placeholder: "Av. Principal, Edificio Cruz, Piso 2"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.direccion]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_81, [
                                            _hoisted_82,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((form.value.ciudad) = $event)),
                                                type: "text",
                                                placeholder: "Caracas"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.ciudad]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_83, [
                                            _hoisted_84,
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((form.value.estadoId) = $event))
                                            }, [
                                                _hoisted_85,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(estados.value, (estado) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: estado.estadoId,
                                                        value: estado.estadoId
                                                    }, _toDisplayString(estado.nombre), 9 /* TEXT, PROPS */, _hoisted_86));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ], 512 /* NEED_PATCH */), [
                                                [_vModelSelect, form.value.estadoId]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_87, [
                                            _hoisted_88,
                                            _createElementVNode("div", _hoisted_89, [
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((form.value.prefixCelular) = $event)),
                                                    class: "prefix-select"
                                                }, _hoisted_92, 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, form.value.prefixCelular]
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((form.value.numeroCelular) = $event)),
                                                    type: "tel",
                                                    placeholder: "4141234567"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, form.value.numeroCelular]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_93, [
                                            _hoisted_94,
                                            _createElementVNode("div", _hoisted_95, [
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((form.value.prefixWhatsapp) = $event)),
                                                    class: "prefix-select"
                                                }, _hoisted_98, 512 /* NEED_PATCH */), [
                                                    [_vModelSelect, form.value.prefixWhatsapp]
                                                ]),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((form.value.numeroWhatsapp) = $event)),
                                                    type: "tel",
                                                    placeholder: "4141234567"
                                                }, null, 512 /* NEED_PATCH */), [
                                                    [_vModelText, form.value.numeroWhatsapp]
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_99, [
                                            _hoisted_100,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((form.value.numeroFijo) = $event)),
                                                type: "tel",
                                                placeholder: "0212-1234567 (Opcional)"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.numeroFijo]
                                            ])
                                        ])
                                    ])
                                ]),
                                _createCommentVNode(" ====== SECCIÓN 3: INFORMACIÓN COMERCIAL ====== "),
                                _createElementVNode("div", _hoisted_101, [
                                    _createElementVNode("div", _hoisted_102, [
                                        _createVNode(_unref(BriefcaseIcon), { size: 16 }),
                                        _hoisted_103
                                    ]),
                                    _createElementVNode("div", _hoisted_104, [
                                        _createElementVNode("div", _hoisted_105, [
                                            _hoisted_106,
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((form.value.tipoComercioId) = $event))
                                            }, [
                                                _hoisted_107,
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposComercios.value, (tipo) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: tipo.tipoComercioId,
                                                        value: tipo.tipoComercioId
                                                    }, _toDisplayString(tipo.nombre), 9 /* TEXT, PROPS */, _hoisted_108));
                                                }), 128 /* KEYED_FRAGMENT */))
                                            ], 512 /* NEED_PATCH */), [
                                                [_vModelSelect, form.value.tipoComercioId]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_109, [
                                            _hoisted_110,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((form.value.paginaWeb) = $event)),
                                                type: "url",
                                                placeholder: "https://www.empresa.com (Opcional)"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.paginaWeb]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_111, [
                                            _hoisted_112,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((form.value.idInstagram) = $event)),
                                                type: "text",
                                                placeholder: "@usuario (Opcional)"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.idInstagram]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_113, [
                                            _hoisted_114,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((form.value.idTikTok) = $event)),
                                                type: "text",
                                                placeholder: "@usuario (Opcional)"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.idTikTok]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_115, [
                                            _hoisted_116,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((form.value.nombreFacebook) = $event)),
                                                type: "text",
                                                placeholder: "Nombre de página Facebook (Opcional)"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.nombreFacebook]
                                            ])
                                        ])
                                    ])
                                ]),
                                _createCommentVNode(" ====== SECCIÓN 4: REPRESENTANTE ====== "),
                                _createElementVNode("div", _hoisted_117, [
                                    _createElementVNode("div", _hoisted_118, [
                                        _createVNode(_unref(UsersIcon), { size: 16 }),
                                        _hoisted_119
                                    ]),
                                    _createElementVNode("div", _hoisted_120, [
                                        _createElementVNode("div", _hoisted_121, [
                                            _hoisted_122,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((form.value.nombreRepresentante) = $event)),
                                                type: "text",
                                                placeholder: "Nombre completo (Opcional)"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.nombreRepresentante]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_123, [
                                            _hoisted_124,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((form.value.cedula) = $event)),
                                                type: "text",
                                                placeholder: "V-12345678 (Opcional)"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.cedula]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_125, [
                                            _hoisted_126,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((form.value.numeroTelefono) = $event)),
                                                type: "tel",
                                                placeholder: "0414-1234567 (Opcional)"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.numeroTelefono]
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_127, [
                                            _hoisted_128,
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((form.value.cargo) = $event)),
                                                type: "text",
                                                placeholder: "Director / Gerente (Opcional)"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [_vModelText, form.value.cargo]
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_129, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[31] || (_cache[31] = ($event) => (isModalOpen.value = false)),
                                        class: "btn btn-secondary"
                                    }, "Cancelar"),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-primary",
                                        disabled: isSaving.value || (form.value.password ? form.value.password !== form.value.confirmPassword : false)
                                    }, [
                                        (isSaving.value)
                                            ? (_openBlock(), _createBlock(_unref(Loader2Icon), {
                                                key: 0,
                                                size: 16,
                                                class: "spinner-icon"
                                            }))
                                            : _createCommentVNode("v-if", true),
                                        _createTextVNode(" " + _toDisplayString(isSaving.value ? 'Guardando...' : (isEditMode.value ? 'Actualizar Usuario' : 'Crear Usuario')), 1 /* TEXT */)
                                    ], 8 /* PROPS */, _hoisted_130)
                                ])
                            ], 32 /* NEED_HYDRATION */)
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
